var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealingPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "600px",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient5",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#84fab0",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8fd3f4",
      stopOpacity: 0.2
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380,280 C360,260 330,260 330,290 C330,320 380,340 380,340 C380,340 430,320 430,290 C430,260 400,260 380,280",
    fill: "#84fab0",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,300 L220,300 M210,290 L210,310",
    stroke: "#8fd3f4",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,300 L620,300 M610,290 L610,310",
    stroke: "#84fab0",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,150 L420,150 M410,140 L410,160",
    stroke: "#8fd3f4",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,300 Q300,200 400,300 T600,300",
    stroke: "#84fab0",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,350 Q300,250 400,350 T600,350",
    stroke: "#8fd3f4",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealingPattern);
export default __webpack_public_path__ + "static/media/healing-pattern.1de8c2d4526cfc7d71b2da920f91a2ad.svg";
export { ForwardRef as ReactComponent };